import React from 'react';
import AboutSection from '../AboutSection';

const AboutPage = () => {
  return (
    <div className="py-10">
      <AboutSection expanded={true} />
    </div>
  );
};

export default AboutPage;